import * as React from 'react'

import Grow from '@mui/material/Grow'
import ClickAwayListener from '@mui/material/ClickAwayListener'

import Popper from '@mui/material/Popper'
import styles from './styles.module.css'

import DeleteIcon from '@mui/icons-material/Delete'

const MoreOptions = ({ buttonRef, options, open, setOpen }) => {
    const handleClose = (event) => {
        if (
            buttonRef.current &&
            buttonRef.current.contains(event.target)
        ) {
            return
        }

        setOpen(false)
    }

    const onItemClick = (item) => {
        // @@
        handleClose()
    }

    const prevOpen = React.useRef(open)
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            buttonRef.current?.focus()
        }

        prevOpen.current = open
    }, [open])

    return (
        <Popper
            style={{ zIndex: 996 }}
            open={open}
            anchorEl={buttonRef.current}
            placement="bottom-end"
            transition
        >
            {({ TransitionProps, placement }) => (
                <Grow {...TransitionProps} style={{
                    transformOrigin:
                        placement === 'bottom-start' ? 'right bottom' : 'right top'
                }}>
                    <div className={styles.accountMenu}>
                        <ClickAwayListener onClickAway={handleClose}>

                            <div className={styles.accountMenuContainer} style={{ padding: '7px 0px' }}>
                                <div className={styles.accountMenuBody}>
                                    {
                                        options.map(x => (
                                            <div className={styles.accountMenuItem} onClick={x?.onClick} style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                                {!!x?.icon ? x?.icon() : null}
                                                <div>
                                                    {x?.name}
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </ClickAwayListener>
                    </div>
                </Grow>
            )}
        </Popper>
    )
}

export default MoreOptions